<template>

  <vx-card :title="cardTitle" class="mb-base"  collapse-action ref="filterCard">

    <!-- Avatar -->
    <div class="vx-row">

      <!-- Avatar Col -->
      <div class="vx-col" id="avatar-col">
        <div class="img-container mb-4">
          <img class="rounded" width="130" height="130"
               :src="userPhoto"/>
        </div>
      </div>

      <!-- Information - Col 1 -->
      <div class="vx-col flex-1" id="account-info-col-1">

        <div class="vx-row mb-6">
          <div class="vx-col sm:w-1/4 w-full">
            <span class="font-semibold"> {{ $t('student-enroll.student-code') }}</span>
          </div>
          <div class="vx-col sm:w-3/4 w-full">
            <v-select v-if="showStudentDdl"
                      :dir="$vs.rtl ? 'rtl' : 'ltr'"
                      :options="students"
                      @input="onStudentChange"
                      @search="fetchOptions"
                      selectOnTab
                      label="code"
                      class="mb-4 md:mb-0"
                      v-model="local.selectedStudent">

              <!--label option-->
              <template #selected-option="{ code }">
                {{ code }}
              </template>

              <!--option list-->
              <template v-slot:option="option">
                {{ option.code }} {{ option.firstNameLocal }} {{ option.lastNameLocal }}
              </template>

              <template v-slot:no-options="{ search, searching }">
                <template v-if="searching">
                  {{$t('general.no-result-for')}} <em>{{ search }}</em>.
                </template>
                <em style="opacity: 0.5;" v-else>{{$t('student-enroll.type-student-code-to-search')}}</em>
              </template>

            </v-select>
            <span v-if="!showStudentDdl && local.selectedStudent">{{ local.selectedStudent.code }}</span>
          </div>
        </div>

        <div class="vx-row mb-6">
          <div class="vx-col sm:w-1/4 w-full">
            <span class="font-semibold"> {{ $t('student-enroll.student-name') }}</span>
          </div>
          <div class="vx-col sm:w-3/4 w-full">
            <span v-if="local.selectedStudent">{{ local.selectedStudent.firstNameLocal + ' ' + local.selectedStudent.lastNameLocal }}</span>
            <span v-else>-</span>
          </div>
        </div>

        <div class="vx-row mb-6">
          <div class="vx-col sm:w-1/4 w-full">
            <span class="font-semibold"> {{ $t('student-enroll.student-curriculum') }}</span>
          </div>
          <div class="vx-col sm:w-3/4 w-full">
            <span v-if="local.selectedStudent">{{ local.selectedStudent.curriculum.nameLocal }}</span>
            <span v-else>-</span>
          </div>
        </div>

      </div>
      <!-- /Information - Col 1 -->

      <!-- Information - Col 2 -->
      <div class="vx-col flex-1" id="account-info-col-2">

        <div class="vx-row mb-6">
          <div class="vx-col sm:w-1/4 w-full" :class="showStudentDdl ? 'mb-5':''">
            <span class="font-semibold"> {{ $t('student-enroll.student-status') }}</span>
          </div>
          <div class="vx-col sm:w-3/4 w-full">
            <span v-if="local.selectedStudent">{{ local.selectedStudent.studentStatus.nameLocal }}</span>
            <span v-else>-</span>
          </div>
        </div>

        <div class="vx-row mb-6">
          <div class="vx-col sm:w-1/4 w-full">
            <span class="font-semibold"> {{ $t('student-enroll.student-telephone') }}</span>
          </div>
          <div class="vx-col sm:w-3/4 w-full">
            <span v-if="local.selectedStudent">{{ local.selectedStudent.telephone }}</span>
            <span v-else>-</span>
          </div>
        </div>

        <div class="vx-row mb-6">
          <div class="vx-col sm:w-1/4 w-full">
            <span class="font-semibold"> {{ $t('student-enroll.student-email') }}</span>
          </div>
          <div class="vx-col sm:w-3/4 w-full">
            <span v-if="local.selectedStudent">{{ local.selectedStudent.email }}</span>
            <span v-else>-</span>
          </div>
        </div>
      </div>

    </div>

  </vx-card>
</template>

<script>
  import vSelect from 'vue-select'
  import {filterStudentEnrollByAcademicPeriod, loadData, state} from "../data";
  import Student from '@/store/modules/profile/student/index';
  import StudentEnroll from '@/store/modules/student-enroll/index';
  import {createNamespacedHelpers} from "vuex";
  import {createHelpers} from "vuex-map-fields";
  import {MODE_ADD} from "@/utils/page-mode";
  import {getXRegisStudentPhoto,config} from "@/utils/upload";

  if (!state.store.Student) state.registerModule(`Student`, Student);
  if (!state.store.StudentEnroll) state.registerModule(`StudentEnroll`, StudentEnroll);

  const {
    mapActions: mapStudentActions,
  } = createNamespacedHelpers(`Student`);

  const {
    mapActions: mapStudentEnrollActions,
  } = createNamespacedHelpers(`StudentEnroll`);

  const {
    mapFields: mapStudentEnrollFields,
  } = createHelpers({
    getterType: `StudentEnroll/getField`,
    mutationType: `StudentEnroll/updateField`,
  });
  const {
    mapFields: mapStudentFields,
  } = createHelpers({
    getterType: `Student/getField`,
    mutationType: `Student/updateField`,
  });

  export default {
    props:{
      mode: String
    },
    components: {
      vSelect,
    },
    data() {
      return {
        local: state.local,
        getXRegisStudentPhoto: getXRegisStudentPhoto,
        urlNoAvatar: config.url.noAvatarImage,
      }
    },
    computed: {
      ...mapStudentEnrollFields({studentEnrollProcessing: 'processing', studentEnrollSuccess: 'success', studentEnrollError: 'error'}),
      ...mapStudentFields({studentProcessing: 'processing',}),
      students(){
        return this.local.students;
      },
      showStudentDdl(){
        return this.mode !== MODE_ADD;
      },
      cardTitle(){
        return this.mode !== MODE_ADD ? this.$t('student-enroll.filter-student'):this.$t('student-enroll.filter-student-info');
      },
      userPhoto() {
        if (this.local.selectedStudent) {
          return getXRegisStudentPhoto(this.local.selectedStudent.code);
        }
        return getXRegisStudentPhoto('');
      },
    },
    watch: {
      academicPeriodProcessing(data) {
        this.local.isProcessing = data;
      },
      academicPeriodConfigProcessing(data) {
        this.local.isProcessing = data;
      },
    },
    methods: {
      //---------------------------------------- State Function ------------------------------------------------------//
      ...mapStudentEnrollActions({
        getStudentEnrollsByFilter: 'getStudentEnrollsByFilter',
      }),
      ...mapStudentActions({
        getStudentsByCodeOrName: 'getStudentsByCodeOrName',
      }),
      //---------------------------------------- Event Function ------------------------------------------------------//
      async fetchOptions(search, loading) {
        if(search && search.length >= 2){
          loading(true);
          this.local.students  = await this.getStudentsByCodeOrName({codeOrName:search, limit:20});
          loading(false);
        }else{
          this.local.students = [];
          this.local.studentEnroll = null;
          this.local.studentEnrolls = [];
          this.local.studentEnrollDetails = [];
        }
      },
      async onStudentChange(){
        let func = {getStudentEnrollsByFilter: this.getStudentEnrollsByFilter};
        await loadData(func);
        filterStudentEnrollByAcademicPeriod();
      }
      //---------------------------------------- Local Function ------------------------------------------------------//


    },
  }
</script>

<style scoped>

</style>
